import { Component, OnInit ,Input} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Users, ROUTE } from 'src/app/models/um/organization';
import { serviceConstants } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { HistoryComponent } from './history/history.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.scss']
})
export class SubmitComponent implements OnInit {
  @Input() public Content: any;
  heading: string;
  content: any;
  formFields;
  formState: string;
  formAction: string;
  appId: string;
  users: Users[] = [];
  action: Subject<any> = new Subject();
  module: string;
  username: string;
  password: string;
  nextstate: string;
  userId: string;
  isSubmit: boolean;
  isAck = false;
  description: string = "";
  title: string;
  email: string;
  isInstruction:boolean;
  programs;
  programid: string="";
   UserType:string="";
  constructor(
    public modalRef: NgbActiveModal,
    public modalRefNew: NgbActiveModal,
    private commonService: UserService,
    private appcommonService: CommonService,
    private summaryService: UmSummaryService,
    private userService: AdministrationSummaryService,
    private modalService: NgbModal,
    public commonservice:CommonService
  ) { }


  ngOnInit() {
    this.isSubmit = false;
    this.UserType=this.commonService.getUserType();
    this.username = this.commonService.getUserName();
    this.userId = this.commonService.getUserDetais().ID;
    this.email = this.commonService.getUserDetais().EMAIL;
    this.getUsers();
    if (this.Content.content !== null) {
      this.formState = this.Content.content.state;
      this.appId = this.Content.content.id;
      this.formAction = this.Content.content.action;

      if (this.formAction === "Assign")
      {
        this.summaryService.getrouteprogram(this.appId).subscribe(prog => {
          if (prog.Id === null || prog.Id === undefined) {
            this.submitForm.get('PROGRAM_ID').enable();
          }
          else {
           
            this.programid = prog.Id;
            this.submitForm.get('PROGRAM_ID').setValue(prog.Id);
            this.submitForm.get('PROGRAM_ID').disable();
            if(prog.IsInOpenQueue=="yes")
            {
              this.submitForm.get('PROGRAM_ID').enable();
            }
          }
 
        });
      }

      this.module = this.Content.content.module;
      if (this.formAction === 'Route')
      this.getNextStatus(this.formState);

      if (this.formAction === 'Return')
       this.getNextStatus('Return');
      let id = 0;
      if (this.formAction === 'Submit') {
        this.isSubmit = true;
        switch (this.module) {
          case "IST":
            id = 3;
            break;
          case "EAP":
            id = 5;
            break;
          case "GRANTSCME":
            id = 7;
            break;
          case "GRANTSSPONSORSHIP":
            id = 11; // used id to display the  instructions accordingly
            break;
          case "GRANTSCHARITABLE":
            id = 9;
            break;
        }
        this.getInstruction(id)
      }
      else
        this.isSubmit = false;
    }
    
    this.getProgram();
    this.submitForm = new UntypedFormGroup({
      COMMENTS: new UntypedFormControl('', Validators.required),
      ASSIGNED_TYPE: new UntypedFormControl('A'),
      PERSON_ID: new UntypedFormControl(''),
      PROGRAM_ID: new UntypedFormControl(this.programid),
    });
    this.disableSelect(true);
  }

  proceed() {
    this.isSubmit = false;
  }

  getProgram() {
    let id=0;
    switch (this.Content.content.module) {
      case "IST":
        id = 2
        break;
      case "EAP":
        id = 5;
        break;
      case "GRANTSCME":
        id = 4;
        break;
      case "GRANTSSPONSORSHIP":
        id = 4;
        break;
      case "GRANTSCHARITABLE":
        id = 4;
        break;
    }
    this.userService.getSummaryData('api/AdminProgram/SubmitProgramsData/'+ this.appId+"/"+id).subscribe(summary => {
      this.programs = summary
    });
  }
  isChecked(){
    this.isAck = !this.isAck;
  }
  getInstruction(id) {
    this.summaryService.getInstruction(id).subscribe(summary => {
      if (summary !== null) {
        this.isInstruction=true;
        this.title = summary.NAME;
        this.description = summary.DESCRIPTION;
      }
      else {
        this.isInstruction = false;
        this.isSubmit = false;
      }
    });
  }

  submitForm = new UntypedFormGroup({
    COMMENTS: new UntypedFormControl('', Validators.required),
    ASSIGNED_TYPE: new UntypedFormControl('A'),
    PERSON_ID: new UntypedFormControl(''),
    PROGRAM_ID: new UntypedFormControl(''),
  })

  getUsers(): void {
    this.userService.getUsers('api/appuser/getworkflowusers/-1').subscribe(summary => {
      this.users = summary;
    });
    
  }

  private getForm(): ROUTE
  {
    const formModel = this.submitForm.value;

    let route = new ROUTE();
    route = {
      ID: formModel.ID || '',
      COMMENTS: formModel.COMMENTS || '',
      ASSIGNED_TYPE: formModel.ASSIGNED_TYPE || '',
      PERSON_ID: formModel.PERSON_ID || '',
      PROGRAM_ID: formModel.PROGRAM_ID || '',
      APPLICATION_ID: this.appId,
      STATUS: this.formAction,
      MODULE: this.module
    }
    if (route.ASSIGNED_TYPE === 'A')
      route.PERSON_ID = this.userId;

    return route;
  }

  save() {
    this.checkPolicy();
  }

  checkPolicy() {
    //this.userService.getSummaryData('api/policy/checkpolicy/' + this.appId + '/' + this.formState + '/' + this.module).subscribe(result => {
      //alert(result);
     // if (result.value === "") {

        // Checking for madatory data submited for all forms or not
        if (this.formAction === 'Submit') {
          if (this.validateControls("Submit")) {

            this.summaryService.saveSubmit(this.getForm()).subscribe(result => {
              if (result.Status === 0) {
                this.commonservice.SuccessBanner('Application submitted successfully');
             //   this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: 'Application submitted successfully'} } });
                
                this.modalRef.close();
              }
              else if(result.ErrorCode == "ALLREQUESTSNOTCLOSED" || result.ErrorCode == "ALLREQUESTSNOTREJECT"
                  || result.ErrorCode == "ALLREQUESTSNOTWITHDRAWN"){
                  this.commonservice.ValidationBanner(result.Message);
                }
              //  this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
             else{
              this.commonservice.ValidationBanner(result.Message);
              }
            });
          }
        }
        else {

            if ((this.formAction === 'Route' || this.formAction === 'Return' || this.formAction === 'Withdraw' || this.formAction === 'Release' || this.formAction === 'Onhold')) {
              if (this.validateControls("Submit")) {
                this.summaryService.saveSubmit(this.getForm()).subscribe(result => {
                  if (result.Status === 0) {
                    if (this.formAction.toLowerCase() == "onhold") {
                     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Application Discarded successfully.' } } });
                      this.commonservice.SuccessBanner("Application on hold")
                    }
                    else {
                      let names="";
                      switch(this.formAction.toLowerCase())
                      {
                        case "route":
                          names="Routed";  
                          break;
                        case "return":
                          names="workflow state updated";
                          break;
                        case "withdraw":
                          names="Withdrawn";
                          break;
                        case "release":
                          names="Released";
                          break;
                        default:
                            names=this.formAction;
                            break;
                      }
                      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: 'Application ' + this.formAction + ' done successfully.' } } });
                      this.commonservice.SuccessBanner("Application " +names + " successfully");
                    }
                    
                    this.modalRef.close();
                  }
                  else {
                    this.commonservice.ValidationBanner(result.Message);
                    //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
                  }
                });
              }
            }
            else {
              if (this.validateControls("Submit")) {
                this.summaryService.saveSubmit(this.getForm()).subscribe(result => {
                  if (result.Status === 0) {
                      let name="";
                      switch(this.formAction.toLowerCase())
                      {
                        case "assign":
                          name="Assigned";  
                          break;
                        case "discard":
                          name="Discarded";
                          break;
                        case "reject":
                          name="Rejected";
                          break;
                        default:
                            name=this.formAction;
                            break;
                      }
                      this.commonservice.SuccessBanner("Application " +name + " successfully");
                      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: 'Application ' + this.formAction + ' done successfully.' } } });
                    
                    this.modalRef.close();
                  }
                  else {
                    this.commonservice.ValidationBanner(result.Message);
                  }
                });
              }
            }
          
        }

  }

  validateControls(type: string): boolean {
    let isValid = true;
    let message = "";
    const formData = this.submitForm.value;

    if (this.formAction === "Assign")
    {
      if (formData.PROGRAM_ID === null || formData.PROGRAM_ID === "") {
        $("#program").addClass("ng-touched ng-invalid validate-error");
        $("#lblprogram").addClass("ng-touched ng-invalid validate-error");
        $("#program").removeClass("ng-untouched ng-valid");
        $("#lblprogram").removeClass("ng-untouched ng-valid");
        message += "Please select Program Category<br/>";
        isValid = false;
      } else {
        $("#program").addClass("ng-untouched ng-valid");
        $("#program").removeClass("ng-touched ng-invalid validate-error");
        $("#lblprogram").addClass("ng-untouched ng-valid");
        $("#lblprogram").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    
    if (formData.ASSIGNED_TYPE == 'S' && (formData.PERSON_ID === null || formData.PERSON_ID === "" )) {
      $("#program").addClass("ng-touched ng-invalid validate-error");
      $("#lblprogram").addClass("ng-touched ng-invalid validate-error");
      $("#program").removeClass("ng-untouched ng-valid");
      $("#lblprogram").removeClass("ng-untouched ng-valid");
      message += "Please select Specific person<br/>";
      isValid = false;
    } else {
      $("#program").addClass("ng-untouched ng-valid");
      $("#program").removeClass("ng-touched ng-invalid validate-error");
      $("#lblprogram").addClass("ng-untouched ng-valid");
      $("#lblprogram").removeClass("ng-touched ng-invalid validate-error");
    }

    switch (type) {
      case "Submit":
        break;
    }
   
    
    if (!isValid)
    this.commonservice.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }

  disableSelect(state: boolean) {
    if(!state)
      this.submitForm.controls['PERSON_ID'].enable();
    else
    {
      this.submitForm.controls['PERSON_ID'].disable();
      this.submitForm.controls['PERSON_ID'].setValue("");

    }

  }
  getNxtState(state: string)
  {
    this.userService.getSummaryData('api/policy/GetNextStateName/' + this.appId + '/' + state + '/' + this.module).subscribe((result) => {
      this.nextstate= result.Data;
    });
  }

  getNextStatus(state: string) {
     this.getNxtState(state);
    // switch (state.toLowerCase())
    // {
    //   case "draft":
    //     nextstate = "Submit";
    //     break;
    //   case "submitted":
    //     nextstate = "Review Ongoing";
    //     break;
    //   case "review ongoing":
    //     nextstate = "Accepted";
    //     break;
    //   case "accepted":
    //     nextstate = "Closed";
    //     break;
    //   case "closed":
    //     nextstate = "";
    //     break;
    // }

   
  }

  getPreviousState(state: string): string {
    let previousstate = "";

    switch (state.toLowerCase()) {
      case "draft":
        previousstate = "";
        break;
      case "submitted":
        previousstate = "Draft";
        break;
      case "review ongoing":
        previousstate = "Submit";
        break;
      case "accepted":
        previousstate = "Review Ongoing";
        break;
      case "closed":
        previousstate = "";
        break;
    }

    return previousstate;
  }

  getChild() {

   const ModelRef= this.modalService.open(HistoryComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'View',
      content: { id: this.appId}
    }
    
  }
}
